import React from 'react'
import { useSearchParams } from 'react-router-dom'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import ContainerPage from '../../components/ContainerPage/ContainerPage'
import DailyProcessing from './DailyProcessing/DailyProcessing'
import ProcessedPayments from './ProcessedPayments/ProcessedPayments'
import ReturnRates from './ReturnRates/ReturnRates'
import { useSelector } from 'react-redux'
import { selectFeatureFlag } from '../../features/featureFlags/selectors'

// WS 2122976: the NACHA return-rate report, as its own tab while the flag is on.
const RETURN_RATES_FLAG = 'NACHA_RETURN_RATE_SCREEN'

/**
 * Single "Payment Processing" workspace hosting the daily review queue ("To Process"), the
 * submitted-that-day view ("Processed") and the resolved-that-day view ("Settled") as tabs, so
 * Processed Payments is no longer a separate top-nav destination. The active
 * tab is reflected in the `?view=` query param for deep-linking; the legacy
 * `/payments/processed-payments` route lands here with initialView="processed".
 */
const PaymentProcessing = ({ initialView = 'toProcess' }) => {
  const [params, setParams] = useSearchParams()
  const returnRatesOn = useSelector(selectFeatureFlag(RETURN_RATES_FLAG))
  const requested = params.get('view') || initialView
  // A link to the tab while the flag is off lands on To Process.
  const view = requested === 'returnRates' && !returnRatesOn ? 'toProcess' : requested

  const setView = (next) => {
    const p = new URLSearchParams(params)
    p.set('view', next)
    setParams(p, { replace: true })
  }

  return (
    <ContainerPage>
      <div className="flex flex-col gap-4">
        <h1 className="text-xl font-semibold text-text-primary">Payment Processing</h1>
        <Tabs
          value={view}
          onChange={(_, next) => setView(next)}
          className="border-b border-divider"
          data-testid="payment-view-tabs"
        >
          <Tab value="toProcess" label="To Process" data-testid="tab-to-process" />
          <Tab value="processed" label="Processed" data-testid="tab-processed" />
          <Tab value="settled" label="Settled" data-testid="tab-settled" />
          {returnRatesOn && <Tab value="returnRates" label="Return rates" data-testid="tab-return-rates" />}
        </Tabs>

        {/* Processed answers "what did we SEND that day"; Settled answers "what RESOLVED that
            day". They used to compete for one date filter, so a payment submitted Monday that
            cleared Thursday showed up under Thursday (Dolly, 2026-07-31). Same table, same
            export — only the instant the date window bounds differs. */}
        {view === 'processed' && <ProcessedPayments embedded basis="submitted" />}
        {view === 'settled' && <ProcessedPayments embedded basis="settled" />}
        {view === 'returnRates' && <ReturnRates />}
        {view !== 'processed' && view !== 'settled' && view !== 'returnRates' && <DailyProcessing embedded />}
      </div>
    </ContainerPage>
  )
}

export default PaymentProcessing
